// extracted by mini-css-extract-plugin
export default {"grid":"Ogtimw","container":"Wlm_43"};